import React, {Component} from "react";
import Owner from "../../models/Owner";
import ServiceIconBox from "../ServiceIconBox";
import {Trans} from "react-i18next";
import CounterFrame from "../CounterFrame";
import {i18nInstance} from "../../localization/core";
import Footer from "../Footer";
import PricePlanComponent from "../PricePlanComponent";
import TestimonialComponent from "../TestimonialComponent";

export default class HomePageContent extends Component/*<any, {textRotate: string}>*/ {
  readonly owner = Owner.instance

  render() {
    return (
      <div className="art-content">
        {/* curtain */}
        <div className="art-curtain"></div>

        {/* top background */}
        <div className="art-top-bg" style={{backgroundImage: 'url(img/bg.jpg)'}}>
          {/* overlay */}
          <div className="art-top-bg-overlay"></div>
          {/* overlay end */}
        </div>
        {/* top background end */}

        {/* swup container */}
        <div className="transition-fade" id="swup">

          {/* scroll frame */}
          <div id="scrollbar" className="art-scroll-frame">

            {/* container */}
            <div className="container-fluid">

              {/* row */}
              <div className="row p-60-0 p-lg-30-0 p-md-15-0">
                {/* col */}
                <div className="col-lg-12">

                  {/* banner */}
                  <div className="art-a art-banner" style={{backgroundImage: 'url(img/bg.jpg)'}}>
                    {/* banner back */}
                    <div className="art-banner-back"></div>
                    {/* banner dec */}
                    <div className="art-banner-dec"/>
                    {/* banner overlay */}
                    <div className="art-banner-overlay">
                      {/* main title */}
                      <div className="art-banner-title">
                        {/* title */}
                        {/*<h1 className="mb-15">Discover my Amazing <br/>Art Space!</h1>*/}
                        <h1 className="mb-15" dangerouslySetInnerHTML={{__html: i18nInstance.t('commons.intros.home')}}/>
                        {/* suptitle */}
                        <div className="art-lg-text art-code mb-25">
                          &lt;<i>code</i>&gt; <Trans>commons.labels.iBuild</Trans> <span
                            className="txt-rotate" data-period="2000"
                            /*data-rotate='[ "web interfaces.", "ios and android applications.", "design mocups.", "automation tools." ]'*/
                            data-rotate={JSON.stringify(this.owner.thingsIBuild.map(el => el.title + '.')).toLowerCase()}
                          > </span> &lt;/<i>code</i>&gt;
                        </div>
                        <div className="art-buttons-frame">
                          {/* button */}
                          <a href="portfolio-3-col-masonry.html"
                             className="art-btn art-btn-md"><span><Trans>actions.exploreNow</Trans></span></a>
                        </div>
                      </div>
                      {/* main title end */}
                      {/* photo */}
                      {/*<img src="img/face-2.png" className="art-banner-photo" alt="Your Name"/>*/}
                    </div>
                    {/* banner overlay end */}
                  </div>
                  {/* banner end */}

                </div>
                {/* col end */}
              </div>
              {/* row end */}

            </div>
            {/* container end */}

            {/* container */}
            <div className="container-fluid">

              {/* row */}
              <div className="row p-30-0">

                {/* col */}
                <div className="col-md-3 col-6">

                  {/* couner frame */}
                  <CounterFrame value={this.owner.yearsExperience} withPlus title={i18nInstance.t('commons.labels.yearsExperience')}/>
                  {/* couner frame end */}

                </div>
                {/* col end */}

                {/* col */}
                <div className="col-md-3 col-6">

                  {/* couner frame */}
                  <CounterFrame value={this.owner.completedProjects} title={i18nInstance.t('commons.labels.completedProjects')}/>
                  {/* couner frame end */}

                </div>
                {/* col end */}

                {/* col */}
                <div className="col-md-3 col-6">

                  {/* couner frame */}
                  <CounterFrame value={this.owner.happyCustomer} title={i18nInstance.t('commons.labels.happyCustomers')}/>
                  {/* couner frame end */}

                </div>
                {/* col end */}

                {/* col */}
                <div className="col-md-3 col-6">

                  {/* couner frame */}
                  <CounterFrame value={this.owner.honorsAndAwards} withPlus title={i18nInstance.t('commons.labels.honorsAndAwards')}/>
                  {/* couner frame end */}

                </div>
                {/* col end */}

              </div>
              {/* row end */}

            </div>
            {/* container end */}

            {/* container */}
            <div className="container-fluid">

              {/* row */}
              <div className="row">

                {/* col */}
                <div className="col-lg-12">

                  {/* section title */}
                  <div className="art-section-title">
                    {/* title frame */}
                    <div className="art-title-frame">
                      {/* title */}
                      <h4><Trans>commons.labels.myServices</Trans></h4>
                    </div>
                    {/* title frame end */}
                  </div>
                  {/* section title end */}

                </div>
                {/* col end */}

                {/* col */}
                {
                  this.owner.services.map(service => <ServiceIconBox service={service} key={service.title}/>)
                }
                {/* col end */}

              </div>
              {/* row end */}

            </div>
            {/* container end */}

            {/* container */}
            <div className="container-fluid">

              {/* row */}
              <div className="row p-0-0">

                {/* col */}
                <div className="col-lg-12">

                  {/* section title */}
                  <div className="art-section-title">
                    {/* title frame */}
                    <div className="art-title-frame">
                      {/* title */}
                      <h4><Trans>commons.labels.pricePlans</Trans></h4>
                    </div>
                    {/* title frame end */}
                  </div>
                  {/* section title end */}

                </div>
                {/* col end */}

                {
                  this.owner.pricesPlans.map((pricePlan, i) => (
                    /* col */
                    <div className="col-lg-4" key={i}>
                      {/* price */}
                      <PricePlanComponent pricePlan={pricePlan}/>
                      {/* price end */}
                    </div>
                    /* price */
                  ))
                }
                {/* grid */}
              </div>
              {/* row end */}

            </div>
            {/* container end */}

            {/* container */}
            <div className="container-fluid">

              {/* row */}
              <div className="row">

                {/* col */}
                <div className="col-lg-12">

                  {/* section title */}
                  <div className="art-section-title">
                    {/* title frame */}
                    <div className="art-title-frame">
                      {/* title */}
                      <h4>Recommendations</h4>
                    </div>
                    {/* title frame end */}
                  </div>
                  {/* section title end */}

                </div>
                {/* col end */}

                {/* col */}
                <div className="col-lg-12">

                  {/* slider container */}
                  <div className="swiper-container art-testimonial-slider" style={{overflow: 'visible'}}>
                    {/* slider wrapper */}
                    <div className="swiper-wrapper">
                      {/* slide */}
                      {
                        this.owner.testimonials.map(testimonial => (
                          <TestimonialComponent testimonial={testimonial}/>
                        ))
                      }
                      {/*<div className="swiper-slide">


                        <div className="art-a art-testimonial">

                          <div className="testimonial-body">

                            <img className="art-testimonial-face" src="img/testimonials/flace-1.jpg" alt="face"/>

                              <h5>Paul Trueman</h5>
                              <div className="art-el-suptitle mb-15">Template author</div>

                              <div className="mb-15">Working with Artur has been a pleasure. Better yet - I alerted them
                                of a minor issue before going to sleep. The issue was fixed the next morning. I couldn't
                                ask for better support. Thank you Artur!
                                This is easily a 5 star freelancer.
                              </div>
                          </div>

                          <div className="art-testimonial-footer">
                            <div className="art-left-side">

                              <ul className="art-star-rate">
                                <li><i className="fas fa-star"></i></li>
                                <li><i className="fas fa-star"></i></li>
                                <li><i className="fas fa-star"></i></li>
                                <li><i className="fas fa-star"></i></li>
                                <li><i className="fas fa-star"></i></li>
                              </ul>

                            </div>
                            <div className="art-right-side">

                            </div>
                          </div>

                        </div>


                      </div>*/}
                      {/* slide end */}
                    </div>
                    {/* slider wrapper end */}
                  </div>
                  {/* slider container end */}

                </div>
                {/* col end */}

                {/* col */}
                <div className="col-lg-12">

                  {/* slider navigation */}
                  <div className="art-slider-navigation">

                    {/* left side */}
                    <div className="art-sn-left">

                      {/* slider pagination */}
                      <div className="swiper-pagination"/>

                    </div>
                    {/* left side end */}

                    {/* right side */}
                    <div className="art-sn-right">

                      {/* slider navigation */}
                      <div className="art-slider-nav-frame">
                        {/* prev */}
                        <div className="art-slider-nav art-testi-swiper-prev">
                          <i className="fas fa-chevron-left"/>
                        </div>
                        {/* next */}
                        <div className="art-slider-nav art-testi-swiper-next">
                          <i className="fas fa-chevron-right"/>
                        </div>
                      </div>
                      {/* slider navigation */}

                    </div>
                    {/* right side end */}

                  </div>
                  {/* slider navigation end */}

                </div>
                {/* col end */}

              </div>
              {/* row end */}

            </div>
            {/* container end */}

            {/* container */}
            <div className="container-fluid">

              {/* row */}
              <div className="row">

                {/* col */}
                <div className="col-6 col-lg-3">
                  {/* brand */}
                  <img className="art-brand" src="img/brands/1.png" alt="brand"/>
                </div>
                {/* col end */}

                {/* col */}
                <div className="col-6 col-lg-3">
                  {/* brand */}
                  <img className="art-brand" src="img/brands/2.png" alt="brand"/>
                </div>
                {/* col end */}

                {/* col */}
                <div className="col-6 col-lg-3">
                  {/* brand */}
                  <img className="art-brand" src="img/brands/3.png" alt="brand"/>
                </div>
                {/* col end */}

                {/* col */}
                <div className="col-6 col-lg-3">
                  {/* brand */}
                  <img className="art-brand" src="img/brands/1.png" alt="brand"/>
                </div>
                {/* col end */}

              </div>
              {/* row end */}

            </div>
            {/* container end */}

            {/* container */}
            <Footer/>
            {/* container end */}

          </div>
          {/* scroll frame end */}

        </div>
        {/* swup container end */}
      </div>
    )
  }
}
